import { StaffApplication } from '../../lib/types/models/staff-application/staff-application'
import { StaffApplicationInput } from '../../lib/types/models/staff-application/staff-application-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateStaffApplication({ id, ...data }: UpdateInput<StaffApplicationInput>) {
  return restApiClient
    .url(constructApiUrl(API.candidate.update.url, { id }))
    .patch<StaffApplication>(data)
}
